<template>
    <div class="section-scene enList">
        <div class="enList-enter"></div>
        <img :src="static_img_url + 'pic/index/logo.png'" class="main-logo">
        <div class="left-div">
            <div class="content content-enter">
                <div>
                    <p><img :src="static_img_url + 'pic/index/logo1.png'" class="logo-vb100"></p>
                </div>
                <div>
                    <p class="gold-tle">报名参选</p>
                </div>
                <div>
                    <div class="steps">
                        <div>
                            <p>征集&推荐2020.10-2021.2</p>
                            <div>
                                1.企业通过官网在线报名； <br/>
                                2.投资机构推荐提名推荐； <br/>
                                3.历届榜单企业定向邀请。
                            </div>
                        </div>
                        <div>
                            <p>评审&奖杯制作2021.3</p>
                            <div>
                                1.审核参选企业报名信息；<br/>
                                2.榜单委员会根据公开信息评估；<br/>
                                3.100+投资专家信息复核。<br/>
                                4.奖杯专属定制
                            </div>
                        </div>
                        <div>
                            <p>公布&颁奖2021.4（待定）</p>
                            <div>
                                1.全网发榜，百家媒体联合发布；<br/>
                                2.峰会颁奖，万人见证颁奖仪式。
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="sign-up rightOblique">
                <div class="enter-msg">
                    <div class="line"></div>
                    <div class="enter-content">
                        <div class="item">
                            <p><img :src="static_img_url + 'pic/index/logo1-black.png'"></p>
                            <p><span class="gold-tle">主榜</span></p>
                            <p><a href="http://vcbeat-vb100.mikecrm.com/cbPkDrl" target="_block" class="btn">报名参选</a></p>
                        </div>
                        <div class="item">
                            <p><img :src="static_img_url + 'pic/index/logo1-black.png'"></p>
                            <p><span class="gold-tle">澎橙奖</span></p>
                            <p><a href="javascript:;" class="btn" @click="preView()">报名参选</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right-div">
            <img :src="static_img_url + 'pic/index/bg_5.png'">
            <div class="agenda-container">
                <div class="agenda">
                    <div class="agenda-month-heade horizontal-break">
                        <div class="span-month" :class="agendaIndex == index ? 'span-month-hand' : ''" v-for="(item, index) in agendaList" :key="index" @click="agendaIndex = index">
                        {{item.date}}
                        <!-- <div :class=" agendaIndex == index ? 'agenda-month-border' : ''"></div> -->
                        </div>
                        <a v-if="agendaList[agendaIndex].signUpHref" :href="agendaList[agendaIndex].signUpHref || 'javascript:;'" target="_blank" class="agenda-sing">报名参选</a>
                    </div>
                    <div class="agenda-item-body">
                        <div class="agenda-item" v-for="(item,index) in agendaList[agendaIndex].content" :key="index">
                            <p class="agenda-item-time">{{item.time}}</p>
                            <!-- <div class="agenda-item-type">
                            <img :src="static_img_url + 'pic/index/logo-huang.png'" >
                            <span> · {{item.title}}</span>
                            </div> -->
                            <a v-if="item.href" :href="item.href || 'javascript:;'" class="agenda-item-content" target="_blank">
                                <img v-if="item.isNew" :src="static_img_url + 'pic/EnList/new.png'" style="width:28px;margin-right:5px">
                                {{item.content}}
                                <i v-if="item.href" class="iconfont">&#xe678;</i>
                            </a>
                            <span v-else class="agenda-item-content">{{item.content}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="enList-leave translate-down">
            <img :src="static_img_url + 'pic/index/org_bg.png'">
        </div>
    </div>
</template>

<script>
import { anima_mixins } from 'js/anima_mixins.js'
import { timeoutSync } from 'js/common.js'
export default {
    mixins:[anima_mixins],
    data(){
        return {
            static_img_url: process.env.VUE_APP_CDN,
            defaultPage: 7,

            //议程
            agendaIndex:0,
            agendaList:[ 
                {
                    date:'价值领域榜',
                    signUpHref:'http://vcbeat-vb100.mikecrm.com/HA6tLZ4',
                    content:[
                        {
                            time:'榜单已发布，点击查看',
                            title:'价值领域榜',
                            content:'医保大数据创新服务',
                            href:process.env.VUE_APP_CDN + 'pic/EnList/list7.png',
                            isNew: true
                        },
                        {
                            time:'榜单已发布，点击查看',
                            title:'价值领域榜',
                            content:'数字化研发',
                            href:process.env.VUE_APP_CDN + 'pic/EnList/list11.png',
                            isNew: true
                        },
                        {
                            time:'榜单已发布，点击查看',
                            title:'价值领域榜',
                            content:'数字化营销',
                            href:process.env.VUE_APP_CDN + 'pic/EnList/list12.png',
                            isNew: true
                        },
                        {
                            time:'榜单已发布，点击查看',
                            title:'价值领域榜',
                            content:'智慧医院大数据创新服务',
                            href:process.env.VUE_APP_CDN + 'pic/EnList/list8.png',
                            isNew: true
                        },
                        {
                            time:'榜单已发布，点击查看',
                            title:'价值领域榜',
                            content:'糖尿病数字疗法',
                            href:process.env.VUE_APP_CDN + 'pic/EnList/list9.png',
                            isNew: true
                        },
                        
                        {
                            time:'榜单已发布，点击查看',
                            title:'价值领域榜',
                            content:'心理健康数字疗法',
                            href:process.env.VUE_APP_CDN + 'pic/EnList/list10.png',
                            isNew: true
                        },
                        {
                            time:'榜单已发布，点击查看',
                            title:'价值领域榜',
                            content:'分子诊断',
                            href: process.env.VUE_APP_CDN + 'pic/EnList/list1.png'
                        },
                        {
                            time:'榜单已发布，点击查看',
                            title:'价值领域榜',
                            content:'免疫诊断',
                            href: process.env.VUE_APP_CDN + 'pic/EnList/list2.png'
                        },
                        {
                            time:'榜单已发布，点击查看',
                            title:'价值领域榜',
                            content:'心脑血管植介入类',
                            href: process.env.VUE_APP_CDN + 'pic/EnList/list3.png'
                        },
                        {
                            time:'榜单已发布，点击查看',
                            title:'价值领域榜',
                            content:'口腔植介入类',
                            href: process.env.VUE_APP_CDN + 'pic/EnList/list4.png'
                        },
                        {
                            time:'榜单已发布，点击查看',
                            title:'价值领域榜',
                            content:'家用医疗设备',
                            href: process.env.VUE_APP_CDN + 'pic/EnList/list5.png'
                        },
                        {
                            time:'榜单已发布，点击查看',
                            title:'价值领域榜',
                            content:'高端影像设备',
                            href: process.env.VUE_APP_CDN + 'pic/EnList/list6.png'
                        },
                        {
                            time:'报名征集中，敬请期待',
                            title:'价值领域榜',
                            content:'口腔民营医疗机构',
                            href: ''
                        },
                        {
                            time:'报名征集中，敬请期待',
                            title:'价值领域榜',
                            content:'医美民营医疗机构',
                            href: ''
                        },
                        {
                            time:'报名征集中，敬请期待',
                            title:'价值领域榜',
                            content:'睡眠健康数字疗法',
                            href:''
                        },
                        {
                            time:'报名征集中，敬请期待',
                            title:'价值领域榜',
                            content:'智慧CDSS',
                            href:''
                        },
                        {
                            time:'报名征集中，敬请期待',
                            title:'价值领域榜',
                            content:'创新疫苗',
                            href:''
                        },
                        {
                            time:'报名征集中，敬请期待',
                            title:'价值领域榜',
                            content:'创新CRO 创新CDMO',
                            href:''
                        },
                        {
                            time:'报名征集中，敬请期待',
                            title:'价值领域榜',
                            content:'商业健康险',
                            href:''
                        },
                        {
                            time:'报名征集中，敬请期待',
                            title:'价值领域榜',
                            content:'智慧药店',
                            href:''
                        }   
                    ]
                },
                {
                    date:'创新产业集群榜',
                    signUpHref:'http://vcbeat-vb100.mikecrm.com/Xz7psxU',
                    content:[
                        {
                            time:'报名征集中，敬请期待',
                            title:'',
                            content:'创新产业集群榜单',
                            href: ''
                        }
                    ]
                },
                {
                    date:'大企业榜',
                    signUpHref:'',
                    content:[
                        {
                            time:'报名征集中，敬请期待',
                            title:'',
                            content:'大药企创新研发实力榜',
                            href: 'http://vcbeat-vb100.mikecrm.com/RUqoCKd'
                        },
                        {
                            time:'报名征集中，敬请期待',
                            title:'',
                            content:'外资企业中国创新力排行榜',
                            href: 'http://vcbeat-vb100.mikecrm.com/iPmDTgd'
                        },
                        {
                            time:'报名征集中，敬请期待',
                            title:'',
                            content:'巨头跨界布局排行榜',
                            href: 'http://vcbeat-vb100.mikecrm.com/OvxrcSX'
                        }
                    ]
                },
            ],
        }
    },
    mounted(){
        this.initMousewheel()
    },
    methods: {
        initMousewheel(){
            $('.agenda-container').mousewheel(function (event, delta) { // 阻止操作父级滚动
                event.stopPropagation();
            });
        },
        preView(){
            this.$emit('setNextPage',this.nextPage - 1)
        },
        async downEnter(){
            await timeoutSync(() => {
                $('.enList-enter').addClass('translate-left')
            },100)
            await timeoutSync(() => {
                $('.content').removeClass('content-enter')
            },600)
            await timeoutSync(()=>{
                $('.sign-up').removeClass('rightOblique')
            },200)
            await timeoutSync(() => {
                $('.enter-msg').addClass('addWidth')
            },600)
            await timeoutSync(() => {
                $('.agenda-container').addClass('joinUp')
                this.$emit('setLock',true)
            },600)
        },
        async upEnter(){
            await timeoutSync(()=>{
                $('.enList-leave').addClass('translate-down')
            },100)
            await timeoutSync(() => {
                this.$emit('setLock',true)
            },600)
        },

        async upLeave(){
            // console.log('PenCheng:上 退出')
            this.$emit('setLock',false)
            $('.sign-up').addClass('rightOblique')
            $('.enter-msg').removeClass('addWidth')
            $('.agenda-container').removeClass('joinUp')
            $('.content').addClass('content-enter')
            await timeoutSync(() => {
                $('.enList-enter').addClass('translate-left')
            },600)
            this.$emit('setActivePage',this.nextPage)
        },
        async downLeave(){
            // console.log('PenCheng:下 退出')
            this.$emit('setLock',false)
            $('.enList-leave').removeClass('translate-down')
            await timeoutSync(()=>{
                this.$emit('setActivePage',this.nextPage)
            },600)
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus';
@import '~styles/animation.stylus';

.enList
    display flex
    flex-direction row
    background #232323
    .enList-enter
        position absolute
        left 0
        width 100vw
        height 100vh
        transition all 1.2s
        z-index 20
        background #232323
    .left-div
        position relative
        width px2vw(1020)
        min-width 730px
        height 100vh
        display flex
        .content
            position absolute
            z-index 10
            .gold-tle
                margin-top px2vh(40)
            .logo-vb100
                width px2vw(540)
            .logo-city
                margin-top px2vh(40)
                height px2vh(56)
            .steps
                display flex
                flex-direction row
                margin-top px2vh(50)
                >div
                    color #FFFFFF
                    font-size 14px
                    line-height 24px
                    >p
                        font-size 16px
                        margin-bottom px2vh(20)
                >div + div
                    margin-left px2vw(40)
            >div
                overflow hidden
                div,img,p
                    transform translateY(0)
                    transition all .6s
            &.content-enter
                >div
                    div,img,p
                        transform translateY(110%)

            @media screen and (max-width: 1600px)
                // left 40px !important
                .gold-tle
                    font-size: 40px !important
                .steps
                    >div
                        font-size 12px
                        >p
                            font-size 14px
        .sign-up
            position absolute
            left 0
            bottom 0
            width 100%
            height px2vh(260)
            min-height 240px
            background #ffffff
            display flex
            justify-content center
            overflow hidden
            transition all .6s
            .enter-msg
                position relative
                width 0
                height 100%
                transition all .6s
                &.addWidth
                    width 100%
                &:after,
                &:before
                    content: ''
                    display inline-block
                    width px2vw(60)
                    height px2vw(60)
                    background:linear-gradient(-45deg,rgba(214,162,77,1),rgba(255,215,149,1));
                    border-radius:50%;
                    position absolute
                    top 30%
                    transform translateY(-50%)
                    z-index 1
                    animation scaleBig 1s ease
                    @media screen and (max-width: 1366px)
                        top 28%
                &:after
                    left px2vw(-30)
                &:before
                    right px2vw(-30)
                .line
                    position absolute
                    width 100%
                    height 2px
                    background rgba(218,218,218,.25)
                    top 30%
                    @media screen and (max-width: 1366px)
                        top 28%
                .enter-content
                    width 100%
                    height 100%
                    display flex
                    flex-direction row
                    justify-content center
                    overflow hidden
                    .item
                        position relative
                        z-index 1
                        width 50%
                        min-width 350px
                        // padding-top 20px
                        &:nth-child(1)
                            text-align right 
                            padding-right: px2vw(110)
                        &:nth-child(2)
                            padding-left: px2vw(110)
                        img
                            width px2vw(235)
                        p
                            margin-top 30px
                            >.gold-tle
                                @media screen and (max-width: 1366px)
                                    font-size 30px !important
                        .btn
                            display inline-flex
                            align-items center
                            justify-content center
                            width:px2vw(120)
                            height:px2vh(40);
                            min-width 100px
                            min-height 30px
                            background:rgba(0,0,0,1);
                            border-radius: 40px
                            font-size:14px;
                            color #FFFFFF
                            &:hover
                                color #d6a24d
                            @media screen and (max-width: 1366px)
                                font-size 13px
    .right-div
        position relative
        width px2vw(900)
        >img 
            position absolute
            z-index -1
            width: 100%
            height 100%
            object-fit: cover
            object-position: 50% 50%
        .agenda-container
            position fixed
            right 0
            bottom 0
            background:rgba(0,0,0,1);
            width px2vw(680)
            height px2vh(850)
            padding px2vh(50) 0 0 px2vw(50)
            transform: translateY(100%)
            transition all .6s
            &.joinUp
                transform: translateY(0)
          .agenda
            position relative
            .agenda-sing
                width:100px;
                height:30px;
                line-height 30px
                text-align center
                color #000000
                font-size 13px
                background:rgba(255,255,255,1);
                border-radius:15px;
                margin-left: auto
                margin-right px2vw(10)
                &:hover
                    color #d6a24d
            .horizontal-break
                margin-bottom 20px
                display: flex;
                flex-flow:row nowrap;
                align-items:center;
            .span-month
                cursor pointer
                position:relative;
                font-weight:400;
                font-style:italic;
                color:rgba(255,255,255,1);
                padding-right: 5px
                transition all .4s
                white-space:nowrap
                span 
                    font-size 20px
                    line-height 32px
                    @media screen and (max-width: 1366px)
                        font-size: 16px;
                        line-height:18px;
                & + .span-month
                    margin-left: px2vw(20)
                &:hover
                    color:rgba(228,157,106,1);
                    background:linear-gradient(0deg,rgba(214,162,77,1) 0%, rgba(255,215,149,1) 100%);
                    -webkit-background-clip:text;
                    -webkit-text-fill-color:transparent;
            .span-month-hand
                position relative
                font-size: 25px;
                line-height 40px
                font-style:italic;
                color:rgba(228,157,106,1);
                background:linear-gradient(0deg,rgba(214,162,77,1) 0%, rgba(255,215,149,1) 100%);
                -webkit-background-clip:text;
                -webkit-text-fill-color:transparent;
                @media screen and (max-width: 1366px)
                    font-size: 16px;
                    line-height:18px;
                &:after
                    content: ''
                    position absolute
                    left 0
                    bottom -10px
                    width: px2vw(60)
                    height:2px;
                    background:linear-gradient(90deg,rgba(214,162,77,1),rgba(255,215,149,1));
                    border-radius:3px;
            .agenda-item-body
                height px2vh(690)
                overflow-y auto
                &::-webkit-scrollbar
                    width:6px;
                    border-radius:5px;
                    background #313131
                &::-webkit-scrollbar-thumb
                    width:6px;
                    height:80px
                    background: #D5D5D5
                    border-radius:3px;
                .agenda-item
                    padding:px2vh(20) 0;
                    font-weight:400;
                    font-style:italic;
                    color:rgba(255,255,255,1);
                    & + .agenda-item
                        border-top:1px solid #494545;
                .agenda-item-time
                    font-size: 16px;
                    font-weight:400;
                    font-style:italic;
                    color:rgba(255,255,255,1);
                .agenda-item-type
                    margin-top: px2vh(20)
                    img 
                        height:16px;
                    span 
                        font-size:18px;
                .agenda-item-content
                    display inline-flex
                    align-items center
                    margin-top:px2vh(20)
                    font-size:18px;
                    color:rgba(228,157,106,1);
                    background:linear-gradient(-45deg,rgba(214,162,77,1) 0%, rgba(255,215,149,1) 100%);
                    -webkit-background-clip:text;
                    -webkit-text-fill-color:transparent;
                    i
                        font-size: 17px
                        transition all .4s
                        margin-left: px2vw(10)
                    &:hover
                        i
                            margin-left: px2vw(16)
                @media screen and (max-width: 1366px)
                    .agenda-item-time
                        font-size: 13px;
                    .agenda-item-type
                        img 
                            height:11px;
                        span 
                            font-size: 13px
                    .agenda-item-content
                        font-size: 13px;
                        i
                            font-size: 9px
    .enList-leave
        position absolute
        width 100vw
        height 100vh
        transition: all .6s
        z-index 20
        img 
            display block
            position absolute
            width: 100%
            height 100%
            object-fit: cover
            object-position: 50% 50%
        .mask
            position relative
            z-index 2
            width 100%
            height 100%
            background:rgba(0,0,0,.6);

</style>